import React, { useState, SyntheticEvent } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import { AffiliateContainer } from "./styles";
import AffiliateOverview from "./AffiliateOverview";
import AffiliateUsers from "./AffiliateUsers";
import AffiliateSettlements from "./AffiliateSettlements";

const Affiliate = () => {
	const [tab, setTab] = useState(0);

	const handleTabChange = (_event: SyntheticEvent, newValue: number) => {
		setTab(newValue);
	};

	return (
		<AffiliateContainer>
			<Tabs value={tab} onChange={handleTabChange} className={"affiliate-tabs"}>
				<Tab label={"Overview"} />
				<Tab label={"Users"} />
				<Tab label={"Settlements"} />
			</Tabs>
			<Box mt={3}>
				{tab === 0 && <AffiliateOverview />}
				{tab === 1 && <AffiliateUsers />}
				{tab === 2 && <AffiliateSettlements />}
			</Box>
		</AffiliateContainer>
	);
};

export default Affiliate;
